import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import store from './store/'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueLazyload from 'vue-lazyload'
import VueCookie from 'vue-cookie'
import monent from 'moment'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'videojs-contrib-hls';
Vue.use(VideoPlayer)
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(vueSwiper);
Vue.use(VueCookie);
Vue.prototype.$monent = monent;
Vue.use(VueLazyload, {
  loading: '../../assets/image/load.gif'
})
Vue.config.productionTip = false;
// 定义全局时间戳过滤器
Vue.filter('formatDate', function(value) {
  return monent(value).format('YYYY-MM-DD HH:mm:ss')
})
if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  window.location.href = "https://admin.zhonghaiyy.com/h5/index.html";
}
// const whiteList = ['/home', '/goods', '/login', '/register'] // 不需要登陆的页面
// router.beforeEach(function (to, from, next) {
//   let params = {
//     params: {
//       token: getStore('token')
//     }
//   }
//   userInfo(params).then(res => {
//     if (res.result.state !== 1) { // 没登录
//       if (whiteList.indexOf(to.path) !== -1) { // 白名单
//         next()
//       } else {
//         next('/login')
//       }
//     } else {
//       store.commit('RECORD_USERINFO', {info: res.result})
//       if (to.path === '/login') { //  跳转到
//         next({path: '/'})
//       }
//       next()
//     }
//   }).catch(res => {
//     console.log(res)
//   })
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js